import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-log-stock',
  templateUrl: './product-log-stock.component.html',
  styleUrls: ['./product-log-stock.component.scss']
})
export class ProductLogStockComponent implements OnInit {

  @Input() productLog;
  @Input() isNew;

  oldDatasMap

  constructor() { }

  ngOnInit(): void {
    this.oldDatasMap = new Map(Object.entries(this.productLog.oldDatas));
  }

}
